import React from 'react';

/**
 * Utility function to detect special symbols in superscript content
 * and return the appropriate CSS class name
 */
export const getSuperscriptClass = (children: React.ReactNode): string | null => {
  // Convert React children to string for analysis
  const getTextContent = (node: React.ReactNode): string => {
    // Narrows an unparsed value to a primitive before using it.
    // oxlint-disable-next-line anti-slop/no-runtime-typeof
    if (typeof node === 'string') {
      return node;
    }
    // Narrows an unparsed value to a primitive before using it.
    // oxlint-disable-next-line anti-slop/no-runtime-typeof
    if (typeof node === 'number') {
      return node.toString();
    }
    if (React.isValidElement(node)) {
      return getTextContent((node.props as { children?: React.ReactNode }).children);
    }
    if (Array.isArray(node)) {
      return node.map(getTextContent).join('');
    }
    return '';
  };

  const textContent = getTextContent(children).trim();

  // Check for small symbols
  if (textContent === '™' || textContent === '®') {
    return 'superscript-small';
  }

  // Check for tall symbols
  if (textContent === '§' || textContent === '‡' || textContent === 'ⓘ') {
    return 'superscript-tall';
  }

  return null;
};

/**
 * Enhanced superscript renderer that automatically detects special symbols
 * and applies the appropriate CSS class
 */
export const renderSuperscript = (children: React.ReactNode): React.ReactElement => {
  const className = getSuperscriptClass(children);

  return React.createElement('sup', className ? { className } : {}, children);
};
